import {
  Order,
  TicketCoverPurchaseBehaviour,
} from "~graphql/typed-document-nodes";

export const shouldShowTicketCover = (order) => {
  const event = order?.event;
  const membership = order?.membership;

  // only show ticket cover if it's optional, skip it if it's always included
  const ticketCoverIsOptional =
    (event?.ticketCover?.isEnabled &&
      event?.ticketCover?.purchaseBehaviour ===
        TicketCoverPurchaseBehaviour.Optional) ||
    (membership?.ticketCover?.isEnabled &&
      membership?.ticketCover?.purchaseBehaviour ===
        TicketCoverPurchaseBehaviour.Optional);

  // we can only offer ticket cover on orders below $15k
  // and where no single item is over $1500 (irrespective of currency)
  // orders over these thresholds get blocked by the ticket cover api

  const maxOrderTotal = 14000; // leave a bit of headroom for varying payment fees e.g. Payment plans or BNPL
  const maxItemPrice = 1500;

  const orderOverThreshold = order?.total > maxOrderTotal;
  const hasItemsOverThreshold = order?.lineItems?.edges?.some(
    (item) => item?.node?.price >= maxItemPrice
  );

  // don't show ticket cover if the user hits "try again" after a transaction
  const hasTransactions = order?.transactions?.edges?.length > 0;

  return (
    order?.total > 0 &&
    ticketCoverIsOptional &&
    !orderOverThreshold &&
    !hasItemsOverThreshold &&
    !hasTransactions
  );
};
